/**
 * Normalise brand names to proper title case.
 * e.g. "mark levinson" → "Mark Levinson"
 */
const BRAND_CORRECTIONS: Record<string, string> = {
  // Mark Levinson
  "mark levinson": "Mark Levinson",
  "marklevinson": "Mark Levinson",
  "mark-levinson": "Mark Levinson",
  "ml": "Mark Levinson",
  // T+A
  "t+a": "T+A",
  "t + a": "T+A",
  "ta": "T+A",
  // Chord Electronics
  "chord": "Chord Electronics",
  "chord electronics": "Chord Electronics",
  // Trinnov
  "trinnov": "Trinnov",
  // Bricasti
  "bricasti": "Bricasti",
  // Lexicon
  "lexicon": "Lexicon",
  // Control4
  "control4": "Control4",
  // Transparent
  "transparent": "Transparent",
  // Acoustic Signature
  "acoustic signature": "Acoustic Signature",
  // Marantz
  "marantz": "Marantz",
  // McIntosh
  "mcintosh": "McIntosh",
  "mac intosh": "McIntosh",
  "mac-intosh": "McIntosh",
  // Naim
  "naim": "Naim",
  "naim audio": "Naim Audio",
  // Linn
  "linn": "Linn",
  // Burmester
  "burmester": "Burmester",
  // dCS
  "dcs": "dCS",
  // Accuphase
  "accuphase": "Accuphase",
  // Luxman
  "luxman": "Luxman",
  // Pass Labs
  "pass labs": "Pass Labs",
  "passlabs": "Pass Labs",
  // Gryphon
  "gryphon": "Gryphon",
  // Simaudio / Moon
  "simaudio": "Simaudio",
  "moon": "Moon",
  // Esoteric
  "esoteric": "Esoteric",
  // Audio Research
  "audio research": "Audio Research",
  "arc": "Audio Research",
  // VTL
  "vtl": "VTL",
  // Conrad-Johnson
  "conrad johnson": "Conrad-Johnson",
  "conradjohnson": "Conrad-Johnson",
  "c-j": "Conrad-Johnson",
  // Ayre
  "ayre": "Ayre",
  // Bryston
  "bryston": "Bryston",
  // Krell
  "krell": "Krell",
  // Parasound
  "parasound": "Parasound",
  // Rotel
  "rotel": "Rotel",
  // Cambridge Audio
  "cambridge audio": "Cambridge Audio",
  "cambridge": "Cambridge Audio",
  // Denon
  "denon": "Denon",
  // Yamaha
  "yamaha": "Yamaha",
  // Sony
  "sony": "Sony",
  // Samsung
  "samsung": "Samsung",
  // LG
  "lg": "LG",
  // Apple
  "apple": "Apple",
};

export function normaliseBrand(brand: string): string {
  if (!brand) return brand;
  const lower = brand.toLowerCase().trim();
  if (BRAND_CORRECTIONS[lower]) return BRAND_CORRECTIONS[lower];
  // Generic title case fallback
  return brand
    .trim()
    .split(/\s+/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

/**
 * Normalise Mark Levinson model numbers.
 * ML333 → No. 333, ml5909 → No. 5909, No.519 → No. 519
 * Plain digits → No. digits
 */
export function normaliseModel(model: string, brand?: string): string {
  if (!model) return model;
  const b = (brand || "").toLowerCase();
  const isML = b.includes("mark levinson") || b.includes("marklevinson");
  if (!isML) return model.trim();

  const trimmed = model.trim();

  // ML followed by digits → No. digits
  const mlMatch = trimmed.match(/^ML(\d+\w*)$/i);
  if (mlMatch) return `No. ${mlMatch[1]}`;

  // No.digits (no space) → No. digits
  const noMatch = trimmed.match(/^No\.(\d+\w*)$/i);
  if (noMatch) return `No. ${noMatch[1]}`;

  // No digits only → No. digits
  const digitsOnly = trimmed.match(/^(\d+[A-Za-z]?)$/);
  if (digitsOnly) return `No. ${digitsOnly[1]}`;

  return trimmed;
}
